import { render, staticRenderFns } from "./corp-docs.vue?vue&type=template&id=13b8ace6&"
import script from "./corp-docs.vue?vue&type=script&lang=js&"
export * from "./corp-docs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13b8ace6')) {
      api.createRecord('13b8ace6', component.options)
    } else {
      api.reload('13b8ace6', component.options)
    }
    module.hot.accept("./corp-docs.vue?vue&type=template&id=13b8ace6&", function () {
      api.rerender('13b8ace6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/conversion-2023/corp-docs.vue"
export default component.exports